import {FileUpload} from '../components/FileUpload'
import {Calendar} from '../components/Calendar'

export default class FormPage {

    init() {
        const config = {

        };

        const fileUpload = new FileUpload();
        fileUpload.init('.js-upload-input', '.js-upload-btn','.js-file-name','.js-remove-upload');

        const calendar = new Calendar();
        calendar.init('.js-datapicker');
    }

}




// WEBPACK FOOTER //
// ./static/js/pages/PitchTender.js